import vClickOutside from "v-click-outside";
import Auth from "@aws-amplify/auth";
import { createNamespacedHelpers } from "vuex";
import { MyGoalService } from "@/services/myGoalsApi";
import Notifications from "@/components/notifications/notifications.vue";

const {
		mapGetters: userGetters,
		mapMutations: userMutations
	} = createNamespacedHelpers("user"),

	{
		mapGetters: filtersGetters,
		mapMutations: filtersMutation
	} = createNamespacedHelpers("filters");

export default {

	components: {Notifications},

	props: ["properties"],

	data() {
		return {
			activeLanguage: (localStorage.getItem("language") || "en").toUpperCase(),
			showLogout: false,
			baselineData: null,
			filters: {
				waste: {
					tooltip: true,
					tooltipContent: [
						{
							text: "tooltips.waste.text1",
							type: "headline"
						},
						{
							text: "tooltips.waste.text2",
							type: "subheadline"
						},
						{
							text: "tooltips.waste.text3",
							type: "text"
						},
						{
							text: "tooltips.waste.text4",
							type: "subheadline"
						},
						{
							text: "tooltips.waste.text5",
							type: "text"
						}
					]
				}
			}
		};
	},

	computed: {
		...userGetters([
			"userInitials",
			"activeOutlet"
		]),

		...filtersGetters([
			"activePeriod"
		])
	},

	mounted() {
		this.load();
	},

	methods: {
		load,
		logout,
		toggleLogoutDropdown,
		closeLogoutDropdown,

		...userMutations({resetUserState: "resetState"}),

		...filtersMutation({resetFilterState: "resetState"})
	},


	directives: {clickOutside: vClickOutside.directive}
};

async function load() {
	const { data } = await MyGoalService.baselineStats();
	this.baselineData = data;
}

function logout(event) {
	event.stopPropagation();

	this.$swal({
		title: this.$t("auth.are_you_sure"),
		text: this.$t("auth.log_out_text"),
		type: "warning",
		showCancelButton: true,
		confirmButtonText: this.$t("auth.yes"),
		cancelButtonText: this.$t("auth.no")
	}).then((result) => {

		if (result.value) {
			Auth.signOut()
				.then(() => {
					this.$sessionService.clearStorage();
					this.$router.push({path: "/sign-in"});
					this.resetUserState();
					this.resetFilterState();
				})
				.catch(err => {
					this.$swal({
						title: this.$t("auth.attention"),
						text: err.message,
						type: "error",
						confirmButtonText: this.$t("auth.ok")
					});
				});
		}
	});
}

function toggleLogoutDropdown() {
	this.showLogout = !this.showLogout;
}

function closeLogoutDropdown() {
	this.showLogout = false;
}

